<div class="row align-items-center justify-content-center px-4 px-md-0 h-100">
    <div class="col-12 col-md-3">
        <div class="text-center mb-4">
            <div class="fw-light lh-1">Ariel Manager</div>
            <h1 class="fw-light">Recuperar Senha</h1>
        </div>
        <form name="form" (ngSubmit)="f.form.valid && onSubmit(f)" #f="ngForm" novalidate>
            <div class="mb-3">
                <input type="email" class="form-control form-control-lg" id="email" name="email"
                    [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" #email="ngModel"
                    placeholder="Email cadastrado" ngModel required>
                <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                    <div *ngIf="email.errors && email.errors['required']">Email é obrigatório</div>
                </div>
            </div>
            <button class="btn btn-primary btn-lg w-100" type="submit" [disabled]="f.form.invalid || loading">
                <div class="spinner-border spinner-border-sm" role="status" *ngIf="loading"></div>
                <span *ngIf="!loading">Enviar email</span>
            </button>
            <a class="btn btn-sm btn-link btn-lg w-100 mt-2" [routerLink]="['/login']">
                Voltar para o login
            </a>
        </form>
    </div>
</div>
